import { defineComponent } from 'vue'
import type { ProviderCardProps } from './types'
import HeaderSm from 'components/headers/sm'

const ProviderCard = defineComponent<ProviderCardProps>({
  setup(props) {
    return () => {
      return (
        <div class="h-[86px] justify-start items-center gap-4 inline-flex">
          <div class="min-w-[86px] h-[86px] bg-white border border-gray-300 justify-center items-center flex">
            <img class="w-full h-full" src={props.provider.iconUrl} style={{
              objectFit: 'contain'
            }} />
          </div>
          <HeaderSm
            title={props.provider.displayName || props.provider.name}
            subtitle="Select assets and liabilities to include in portfolio"
          />
        </div>
      )
    }
  }
})

ProviderCard.props = ['provider']

export default ProviderCard
